import { Reducer } from 'redux';

// Actions

export const toogleHideOtherMarkets = (hide: boolean) => ({
  type: 'TOGGLE_HIDE_OTHER_MARKETs' as const,
  hide,
});

type HideOtherMarketsAction = ReturnType<typeof toogleHideOtherMarkets>;

// Reducer

type HideOtherMarketsState = boolean;

const defaultState: HideOtherMarketsState = false;

// @cached
export const userHideOtherMarketsReducer: Reducer<
  HideOtherMarketsState,
  HideOtherMarketsAction
> = (state = defaultState, action): HideOtherMarketsState => {
  switch (action.type) {
    case 'TOGGLE_HIDE_OTHER_MARKETs':
      return action.hide;
    default:
      return state;
  }
};
